/* eslint-disable import/prefer-default-export */
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { formatOrderNoteMessage } from '../../../../util/utils';
import {
  generateLinkForWava,
  formatPaymentLinks,
  getShopLink,
  hasWavaMethods
} from '../../../../services/paymentMethodsService';
import { usePaymentGatewayConnections } from '../../Payments/hooks/usePaymentGatewayConnections';


export const useSendPaymentLinks = ({ order, platform, onSendPaymentLink, onClose }) => {
  const { retailer_info } = useSelector((reduxState) => reduxState.retailerUsersReducer);

  const [paymentMethods, setPaymentMethods] = useState([]);
  const [saving, setSaving] = useState(false);

  const selectedPaymentMethods = paymentMethods.filter((p) => p.selected);
  const shopLink = getShopLink(order, true);

  const { serializedPaymentMethods } = usePaymentGatewayConnections({ order });

  useEffect(() => {
    setPaymentMethods(serializedPaymentMethods);
  }, [serializedPaymentMethods]);

  const toggleMethod = (methodKey) => {
    setPaymentMethods((prev) => prev.map((m) => (m.key === methodKey ? { ...m, selected: !m.selected } : m)));
  };

  const formatMessageAndSend = (linkText) => {
    let text = '';
    if (order) {
      text = formatOrderNoteMessage(order, retailer_info, platform, !!linkText);
    }
    if (linkText) {
      text += text ? `\n${linkText}` : linkText;
    }
    onSendPaymentLink(text);
  };

  const handleSendBy = () => {
    formatMessageAndSend('');
    if (onClose) onClose();
  }

  const handleOnSendPaymentLink = () => {
    if (!selectedPaymentMethods.length) return;

    setSaving(true);

    if (hasWavaMethods(selectedPaymentMethods)) {
      generateLinkForWava(order, retailer_info.id)
        .then((wavaLink) => {
          const linkText = formatPaymentLinks(selectedPaymentMethods, wavaLink, order);
          formatMessageAndSend(linkText);
          if (onClose) onClose();
        })
        .catch((err) => {
          if (typeof window !== 'undefined' && window.showtoast) {
            window.showtoast(err.message);
          }
        })
        .finally(() => {
          setSaving(false);
        });
    } else {
      const linkText = formatPaymentLinks(selectedPaymentMethods, null, order);
      formatMessageAndSend(linkText || shopLink);
      setSaving(false);
      if (onClose) onClose();
    }
  };

  return {
    paymentMethods,
    toggleMethod,
    handleOnSendPaymentLink,
    handleSendBy,
    saving,
    selectedPaymentMethods
  };
};
